import { Provider } from 'react-redux';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import store from '../store';
import Theme from '../utils/theme';
import Router from './Router/Router';
import LoadingIndicator from './layout/LoadingIndicator';

// Initialize i18n
import '../utils/i18n';

// Generate unique user code if not present
const makeId = (length: number): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

if (!localStorage.getItem('user_code')) {
  localStorage.setItem('user_code', makeId(8));
}

export default function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={Theme}>
        <CssBaseline />
        <Router />
        <LoadingIndicator />
      </ThemeProvider>
    </Provider>
  );
}
